import { Role } from '../types'

export type Permission =
  | 'leads.view'
  | 'leads.edit'
  | 'leads.delete'
  | 'notes.edit'
  | 'forms.manage'
  | 'landings.manage'
  | 'team.manage'
  | 'settings.manage'
  | 'integrations.manage'

const MATRIX: Record<Role, Permission[]> = {
  propietario: [
    'leads.view',
    'leads.edit',
    'leads.delete',
    'notes.edit',
    'forms.manage',
    'landings.manage',
    'team.manage',
    'settings.manage',
    'integrations.manage',
  ],
  administrador: [
    'leads.view',
    'leads.edit',
    'leads.delete',
    'notes.edit',
    'forms.manage',
    'landings.manage',
    'team.manage',
    'settings.manage',
    'integrations.manage',
  ],
  comercial: ['leads.view', 'leads.edit', 'notes.edit'],
  lectura: ['leads.view'],
}

export function can(role: Role, permission: Permission): boolean {
  return MATRIX[role].includes(permission)
}
